<div class="ConfigureReportsDialog" [formGroup]="inputForm">
  <div class="row">
    <div class="col col-12 col-sm-4">
      <mat-label>Report state</mat-label>
    </div>
    <div class="col col-12 col-sm-8">
      <app-select label="Select reports state" [items]="reportItems" formControlName="report_toggle"></app-select>
    </div>
  </div>
</div>
